export default {
    _prefix: "SideDrawer",
    header: {
        assignEvaluation: "Assign Evaluation",
    },
    labels: {
        currentAssignee: "Current Assignee",
        assignee: "Assignee",
        assignToMe: "Assign To Me",
        unassign: "Unassign",
    },
    placeholderText: {
        userNotAssigned: "Not Assigned",
        unknown: "Unknown",
    },
    tooltip: {
        assignee:
            "An assignee is the user who must take the next supervisory or managerial action on the evaluation.",
        privateComments:
            "Private Comments are not viewable by the Agent in the evaluation.",
    },
    banner: {
        infoMessage:
            "{{#Strong}}Note:{{/Strong}} After assigning, you may no longer have the permissions needed to make further changes.",
    },
    errors: {
        assignerHasNoUpdatePermissions:
            "You do not have any permissions needed to update this evaluation.",
        assignerHasNoAssignPermission:
            "You do not have the permissions needed to assign this evaluation.",
        assigneeHasNoNecessaryPermission:
            "The selected individual does not have the permissions needed to be assigned.",
    },
};
